import { __decorate } from "tslib";
import { Component, Vue, Ref } from 'vue-property-decorator';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import AlarmList from '@blade-sxp/alarm-center/pages/components/alarm-list/index.vue';
import FormFilter from '@blade-sxp/alarm-center/pages/components/form-filter/index.vue';
import lang from '@blade/common/pages/alert-details/lang/index';
import { getUserLastOperationRecord } from '@blade/common/api/alarm-center';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
let AlarmCenter = class AlarmCenter extends Vue {
    alarmCenterList;
    userLastOperationRecord = {};
    showAlarmList = false;
    created() {
        this.getUserLastOperationRecordFunc();
    }
    getUserLastOperationRecordFunc() {
        getUserLastOperationRecord(['alarmList'])
            .then((res) => {
            if (res) {
                Object.keys(res).map((item) => {
                    if (item === 'alarmList') {
                        this.userLastOperationRecord = { ...res['alarmList'].operationRecord };
                        AlarmCenterModule.updateSearchdata({
                            ...this.userLastOperationRecord,
                        });
                        this.showAlarmList = true;
                    }
                });
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    updateAlarmList() {
        this.$refs.alarmCenterList.formSerch(true);
    }
};
__decorate([
    Ref()
], AlarmCenter.prototype, "alarmCenterList", void 0);
AlarmCenter = __decorate([
    Component({
        name: 'AlarmCenter',
        components: { AuthItem, AlarmList, FormFilter },
        i18n: {
            messages: lang,
        },
    })
], AlarmCenter);
export default AlarmCenter;
